import { render } from "./index.vue?vue&type=template&id=d805e302&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=d805e302&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\riverside\\project\\mall\\skill-supply\\skill-supply-mall-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d805e302"]])

export default __exports__